import React, { useState, useEffect, useRef } from 'react'

import {

    Button, Dialog, Grid, Icon, RadioGroup,
    Typography, FormLabel, FormHelperText, FormControl,
    FormGroup, FormControlLabel, Checkbox, Radio, Select
} from '@material-ui/core'

import Scrollbars from "rc-scrollbars";
import CloseIcon from '@material-ui/icons/Close';
import RichTextEditor from 'react-rte';
import { InputBaseField, SelectField, TextareaField } from '../../../components/InputField/InputField';
import { Label, DraggableComponent } from '../../../components/UiElements/UiElements'
import { PostDataAPI } from '../../../Services/APIService';
import { withSnackbar } from "../../../components/Message/Alert";
import { lstStates, lstCountry, lstMonths, documentType } from '../../../../src/components/Common/Lookup';
import useStyles from "./styles";
import { validateEmail, validatePhoneNumber, allowedAttachmentsImages, handleNumberKeyPress, getFormatedDate } from '../../../../src/components/Common/Extensions';
import PreviewPhoto from '../../../assets/img/common/Loren-Solorzano-identity.jpg';
import axios from 'axios';
import DialogLoader from '../../../components/Loader/DialogLoader';
import CropImage from '../cropImg/CropExample';


function EditRequest({ dialogOpenClose, handleClose, handleSuccessClose, record, isPreviewMode, ...props }) {
    const classes = useStyles();
    const commonAttachments = allowedAttachmentsImages();
    const [isLoading, setIsLoading] = useState(false);
    const [state, setState] = useState((record && record.applicationId > 0) ? record : {});
    const { showMessage } = props;
    const [identityImage, setIdentityImage] = useState({ file: null, fileToSend: null, fileName: null });

    const [fileUrl, setFileUrl] = useState(null);
    const [fieldName, setFieldName] = useState(null);


    const onSave = async (croppedImage, fieldName) => {

        const name = fieldName.files[0].name;
        const lastDot = name.lastIndexOf('.');
        const ext = name.substring(lastDot + 1);
        switch (ext) {
            case commonAttachments[ext]:
                break;
            default:
                showMessage("Error", "File format is not allowed,\n Only files with the following extensions are allowed: .png .jpg .jpeg", "error", 3000);
                return;
        }

        setIdentityImage({
            file: croppedImage,
            fileToSend: croppedImage,
            fileName: fieldName.files[0].name
        });

        setTimeout(() => {
            setCropImageDialog(false)
        })
    };


    const handleFileChange = (e) => {
        openCropImage()
        const selectedFile = e.target.files[0];
        const url = URL?.createObjectURL(selectedFile);
        setFileUrl(url);
        setFieldName(e.target)
    }




    function uploadSingleFile(e) {
        if (e.target.files == null || e.target.files.length <= 0)
            return
        const name = e.target.files[0].name;
        const lastDot = name.lastIndexOf('.');
        const fileName = name.substring(0, lastDot);
        const ext = name.substring(lastDot + 1);
        switch (ext) {
            case commonAttachments[ext]:
                break;
            default:
                showMessage("Error", "File format is not allowed,\n Only files with the following extensions are allowed: .png .jpg .jpeg", "error", 3000);
                return;
        }

        setIdentityImage({
            file: URL.createObjectURL(e.target.files[0]),
            fileToSend: e.target.files[0],
            fileName: e.target.files[0].name
        });


    }

    const inputFile = useRef(null);

    const uploadFile = () => {

        inputFile.current.click();
    };

    const [selectedOption, setSelectedOption] = useState('SSN');

    const handleOptionChange = (event) => {
        setSelectedOption(event.target.value);
    };
    const handleSelectChange = (e) => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
        if (name === 'childCount') {
            var existingChildDetails = [...lstChildDetail];
            existingChildDetails = existingChildDetails.map(child => ({ ...child, isDeleted: false }));
            for (let i = value; i < existingChildDetails.length; i++) {
                existingChildDetails[i] = { ...existingChildDetails[i], isDeleted: true };
            }
            var totalCount = value > existingChildDetails.length ? value : existingChildDetails.length;
            const newChildDetails = Array.from({ length: totalCount }, (_, index) => {
                if (index < existingChildDetails.length) {
                    //existingChildDetails[index].isDeleted = false;
                    return existingChildDetails[index];
                }
                return { childId: 0, fullName: '', Gender: '', age: '', applicationId: record?.applicationId > 0 ? record.applicationId : 0, isDeleted: false };
            });

            setLstChildDetail(newChildDetails);
        }
    }
    const handleChange = e => {
        const { name, value } = e.target;

        if (value.trim() === "" && value !== "") {
            return;
        }

        const trimmedValue = value.replace("/\s{2,}/g", "");

        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
    }
    const handleStatusCheckChange = (e, index) => {
        const { name, checked } = e.target;
        setLstHousholdStatus((prevState) => {
            const updatedStatus = [...prevState];
            updatedStatus[index].checked = checked;
            return updatedStatus;
        })


    }
    const handleChildChange = (e, index) => {
        const { name, value } = e.target;
        const newInputs = [...lstChildDetail];
        newInputs[index][name] = value;
        setLstChildDetail(newInputs);
    }
    var allowedZipCodes = [
        "33309", "33311", "33313", "33319", "33351",
        "32808", "32809", "32805", "32811", "32839"
    ];
    const handleZipCodeChange = (e) => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }))
        if (value.trim() != '' && value.trim().length > 4) {
            getStateAndCityOnZipCodeChange(value);
        }

    };
    const removeSpacesFromKeys = (obj) => {
        const newObj = {};
        Object.keys(obj).forEach((key) => {
            const newKey = key.replace(/\s/g, '_');
            newObj[newKey] = obj[key];
        });
        return newObj;
    };
    const getStateAndCityOnZipCodeChange = (zipCode) => {
        axios
            .get(`https://api.zippopotam.us/us/${zipCode}`)
            .then((response) => {
                if (response.data != null && response.data.places != null && response.data.places.length > 0) {

                    const { state, state_abbreviation, place_name } = removeSpacesFromKeys(response.data.places[0]);

                    setState(prevState => ({
                        ...prevState,
                        ['state']: state_abbreviation,
                        ['city']: place_name
                    }))
                }
            })
            .catch((error) => {
                //console.log('Error fetching location data:', error);
            });
    };

    const [isData, setIsData] = useState(false);

    const handlePhoneChange = (e) => {
        const { name, value } = e.target;

        if (e.target.value != "") {
            const re = /^[0-9\b]+$/;
            e.target.value = e.target.value
                .replace(" ", "")
                .replace("(", "")
                .replace(")", "")
                .replace("-", "");
            const { name, value } = e.target;
            if (e.target.value === "" || re.test(e.target.value)) {
                var cleaned = ("" + e.target.value).replace(/\D/g, "");
                var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
                if (match) {
                    var intlCode = match[1] ? "+1 " : "",
                        number = [
                            intlCode,
                            "(",
                            match[2],
                            ") ",
                            match[3],
                            "-",
                            match[4],
                        ].join("");

                    setState((prevState) => ({
                        ...prevState,
                        [name]: number,
                    }));
                    return;
                }
                setState((prevState) => ({
                    ...prevState,
                    [name]: value,
                }));
            } else {
                if (!re.test(e.target.value)) {
                    e.preventDefault();
                }
            }
        } else {
            setState((prevState) => ({
                ...prevState,
                [name]: value,
            }));
        }
    };

    const [errorMessages, setErrorMessages] = useState({});

    const genderChange = (e) => {
        const { name, value } = e.target;

        setState(prevState => ({
            ...prevState,
            name: value
        }))
    }

    function toDayDate() {
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();

        today = yyyy + '-' + mm + '-' + dd;
        return today;
    }

    const Validate = (errorList) => {
        if (!state.parentName) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorParentName: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorParentName: false
            }));
        }

        if (!state.childCount) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorChildCount: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorChildCount: false
            }));
        }

        if (!state.householdIncome) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorHouseholdIncome: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorHouseholdIncome: false
            }));
        }

        if (!state.familySize) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorFamilySize: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorFamilySize: false
            }));
        }

        if (!state.email) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorEmailAddress: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorEmailAddress: false
            }));
        }

        if (!state.phone || !validatePhoneNumber(state.phone)) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPhone: true
            }));
            errorList.push(true);
        }

        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPhone: false
            }));
        }

        if (!state.address) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorAddress: true
            }));
            errorList.push(true);
        }

        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorAddress: false
            }));
        }

        if (!state.city) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorCity: true
            }));
            errorList.push(true);
        }

        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorCity: false
            }));
        }


        if (!state.zip) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorZip: true
            }));
            errorList.push(true);
        }

        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorZip: false
            }));
        }
        if (state.zip && allowedZipCodes.some(a => a == state.zip)) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorInvalidZip: false
            }));
        }

        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorInvalidZip: true
            }));
            errorList.push(true);
        }

        if (!state.applicantSignature) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorSignature: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorSignature: false
            }));
        }

        if (!state.applicantInitials) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorInitials: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorInitials: false
            }));
        }

        if (!state.comments) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorComments: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorComments: false
            }));
        }
        if (!lstHousholdStatus.some(item => item.checked)) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorHouseHoldStatus: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorHouseHoldStatus: false
            }));
        }
        if (lstChildDetail && lstChildDetail.length > 0) {
            const hasNameError = lstChildDetail.some((t) => !t.isDeleted && !t.fullName);
            const hasAgeError = lstChildDetail.some((t) => !t.isDeleted && !t.age);
            const hasGenderError = lstChildDetail.some((t) => !t.isDeleted && !t.gender);

            if (hasNameError) {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorChildName: true
                }));
                errorList.push(true);
            }
            else {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorChildName: false
                }));
            }

            if (hasAgeError) {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorChildAge: true
                }));
                errorList.push(true);
            }
            else {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorChildAge: false
                }));
            }

            if (hasGenderError) {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorChildGender: true
                }));
                errorList.push(true);
            }
            else {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorChildGender: false
                }));
            }
        }

        if (!identityImage.file && !state.identityProof) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorIdentityImage: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorIdentityImage: false
            }));
        }




    }
    const [lstHousholdStatus, setLstHousholdStatus] = useState([
        { value: "Experienced homelessness this year", checked: false },
        { value: "Single Parent Household", checked: false },
        { value: "Foster Children/ Adopted Children", checked: false },
        { value: "On Government Assistance", checked: false },
        { value: "A Parent Who Incarcerated", checked: false },
        { value: "Have Limited Access To Healthy Foods", checked: false }
    ]);
    const updateApplicantInformation = () => {
        let errorList = [];
        Validate(errorList);
        if (errorList.length < 1) {

            //state.status = "Applied"
            setIsLoading(true);
            const householdStatusArray = lstHousholdStatus.filter(item => item.checked).map(item => item.value);
            state.householdStatus = householdStatusArray.join(',');
            var method = "everychildchristmas/add";
            if (record && record.applicationId > 0)
                method = "everychildchristmas/update";
            const formData = new FormData();

            for (var key in state) {
                if (state[key] && key != "fileToSend"
                    && key != "fileName"
                    && key != "identityFile"
                    && key != "identityName"
                    && key != "encUserID"
                    && key !== "lstChildDetail"
                )
                    formData.append(key, state[key]);
            }
            formData.append("identityFile", identityImage.fileToSend ? identityImage.fileToSend : '');
            formData.append("identityName", identityImage.fileName ? identityImage.fileName : '');
            const lstFilteredChildDetail = lstChildDetail.filter(item => {
                return item.childId > 0 || !item.isDeleted;
            });
            for (var i = 0; i < lstFilteredChildDetail.length; i++) {
                formData.append(`lstChildDetail[${i}][childId]`, lstFilteredChildDetail[i].childId);
                formData.append(`lstChildDetail[${i}][applicationId]`, lstFilteredChildDetail[i].applicationId);

                formData.append(`lstChildDetail[${i}][fullName]`, lstFilteredChildDetail[i].fullName);
                formData.append(`lstChildDetail[${i}][gender]`, lstFilteredChildDetail[i].gender);
                formData.append(`lstChildDetail[${i}][age]`, lstFilteredChildDetail[i].age);

                formData.append(`lstChildDetail[${i}][isDeleted]`, lstFilteredChildDetail[i].isDeleted);
                if (lstChildDetail[i].childId > 0) {
                    formData.append(`lstChildDetail[${i}][createDate]`, lstFilteredChildDetail[i].createDate);
                }
            }

            PostDataAPI(method, formData, true, "formData").then((result) => {
                setIsLoading(false);
                if (result.success) {
                    if (result.data) {
                        handleSuccessClose("Application updated successfully");
                    }
                    else {
                        showMessage("Error", "Error updating application, please contact administrator", "error", 3000);
                    }
                }
                else {
                    showMessage("Error", result.message, "error", 3000);

                }
            })
        }

    }
    const [lstChildDetail, setLstChildDetail] = useState([]);
    const loadApplicationsDetail = () => {

        setIsLoading(true);
        //var param = [filter ? filter : filters.salesFilter];
        PostDataAPI("everychildchristmas/getECCPDetailByApplication", record.applicationId).then((result) => {
            setIsLoading(false);
            if (result.success && result.data) {
                setLstChildDetail(result.data);
            }
            else {
                showMessage("Error", result.message, "error", 3000);
            }

        });
    }
    useEffect(() => {
        if (record && record.applicationId > 0) {
            loadApplicationsDetail();
            if (record.householdStatus) {
                var householdStatusArray = record.householdStatus.split(',');
                const updatedStatus = lstHousholdStatus.map(item => ({
                    ...item,
                    checked: householdStatusArray.some(stat => item.value?.toLocaleLowerCase() === stat?.toLocaleLowerCase())
                }));
                setLstHousholdStatus(updatedStatus);
            }
        }

    }, []);

    const [cropImagedialog, setCropImageDialog] = useState(false);

    const openCropImage = () => {
        setCropImageDialog(true)
    }

    const closeCropImage = () => {
        fieldName.value = ""
        setCropImageDialog(false)
    }



    return (
        <Dialog
            classes={{ paper: classes.dialogPaper }}
            disableBackdropClick
            disableEscapeKeyDown
            open={dialogOpenClose}
            PaperComponent={DraggableComponent}
            maxWidth="lg"
            {...props} >
            <div className={classes.dialogContent}>


                {cropImagedialog ?
                    <CropImage open={openCropImage} onClose={closeCropImage} fieldName={fieldName} src={fileUrl} onSave={onSave}></CropImage> : ''
                }

                <div className={classes.box}>
                    <div className={classes.header} id="draggable-dialog-title">
                        <Typography className={classes.title}>{record?.applicationId > 0 ? `Edit Request: F-${record.applicationId}` : 'Add new Application'}</Typography>

                        <Icon className={classes.closeIcon} onClick={handleClose} color="primary"><CloseIcon /></Icon>
                    </div>


                    {isLoading ? <DialogLoader></DialogLoader> : ''}
                    <Scrollbars autoHeight autoHeightMax={480}>
                        <div className={classes.content}>

                            <Grid container spacing={2}>
                                <Grid item sm={12} md={12} lg={12} xl={12}>

                                    <h3 className={classes.sectionHeading}>Personal Information</h3>

                                    <Grid container spacing={3}>

                                        <Grid item sm={6} md={6} lg={6} xl={6}>
                                            <Grid row >
                                                <Label title="Parent/Guardian (Full Name)" size={12} mandatory={true} />
                                                <InputBaseField
                                                    name="parentName"
                                                    value={state.parentName}
                                                    onChange={handleChange}
                                                    placeholder="Parent/Guardian (Full Name)"
                                                    type="text"
                                                    MaxLength={100}
                                                    IsDisabled={isPreviewMode}
                                                />
                                                {errorMessages.errorParentName && !state.parentName ? (<FormHelperText style={{ color: "red" }} >
                                                    Please enter Parent/Guardian full name
                                                </FormHelperText>) : ('')}
                                            </Grid>

                                        </Grid>


                                        <Grid item sm={6} md={6} lg={6} xl={6}>
                                            <Grid row >
                                                <Label title="Household Income" size={12} mandatory={true} />
                                                <Select
                                                    size="small"
                                                    native
                                                    name="householdIncome"
                                                    value={state?.householdIncome}
                                                    onChange={handleSelectChange}
                                                    disabled={isPreviewMode}
                                                    placeholder="Select"
                                                    label="Select"
                                                    className={classes.selectBaseInput}
                                                >
                                                    <option value="" selected="selected">
                                                        Select household income
                                                    </option>
                                                    <option value="Less than $20,000 per year">Less than $20,000 per year</option>
                                                    <option value="$20,000 - $40,000 per year">$20,000 - $40,000 per year</option>
                                                    <option value="$40,001 - $60,000 per year">$40,001 - $60,000 per year</option>
                                                    <option value="$60,001 - $80,000 per year">$60,001 - $80,000 per year</option>
                                                    <option value="$80,001 - $100,000 per year">$80,001 - $100,000 per year</option>
                                                    <option value="$100,001 - $150,000 per year">$100,001 - $150,000 per year</option>
                                                    <option value="$150,001 - $200,000 per year">$150,001 - $200,000 per year</option>
                                                    <option value="More than $200,000 per year">More than $200,000 per year</option>
                                                </Select>
                                                {errorMessages.errorHouseholdIncome && !state.householdIncome ? (<FormHelperText style={{ color: "red" }} >
                                                    Please select household income
                                                </FormHelperText>) : ('')}
                                            </Grid>

                                        </Grid>

                                    </Grid>
                                    <Grid container spacing={3}>

                                        <Grid item sm={6} md={6} lg={6} xl={6}>
                                            <Grid row >
                                                <Label title="Referred By" size={12} />
                                                <InputBaseField
                                                    name="referredBy"
                                                    value={state.referredBy}
                                                    onChange={handleChange}
                                                    placeholder="Referred By"
                                                    type="text"
                                                    MaxLength={100}
                                                    IsDisabled={isPreviewMode}
                                                />
                                            </Grid>

                                        </Grid>
                                        <Grid item sm={3} md={3} lg={3} xl={3}>
                                            <Grid row >
                                                <Label title="No. of people in household" size={12} mandatory={true} />
                                                <InputBaseField
                                                    name="familySize"
                                                    value={state.familySize}
                                                    onChange={handleChange}
                                                    placeholder="Number of people in household"
                                                    type="text"
                                                    onKeyPress={handleNumberKeyPress}
                                                    MaxLength={2}
                                                    IsDisabled={isPreviewMode}
                                                />
                                                {errorMessages.errorFamilySize && !state.familySize ? (<FormHelperText style={{ color: "red" }} >
                                                    Please enter number of people in household
                                                </FormHelperText>) : ('')}
                                            </Grid>

                                        </Grid>
                                        <Grid item sm={3} md={3} lg={3} xl={3}>
                                            <Grid row >
                                                <Label title="No. of Children" size={12} mandatory={true} />
                                                <Select
                                                    size="small"
                                                    native
                                                    name="childCount"
                                                    value={state?.childCount}
                                                    onChange={handleSelectChange}
                                                    disabled={isPreviewMode}
                                                    placeholder="Select"
                                                    label="Select"
                                                    className={classes.selectBaseInput}
                                                >
                                                    <option value="" selected="selected">
                                                        Select No. of Children
                                                    </option>
                                                    <option value="1">1</option>
                                                    <option value="2">2</option>
                                                    <option value="3">3</option>
                                                    <option value="4">4</option>
                                                </Select>
                                                {errorMessages.errorChildCount && !state.childCount ? (<FormHelperText style={{ color: "red" }} >
                                                    Please select no. of children
                                                </FormHelperText>) : ('')}
                                            </Grid>

                                        </Grid>
                                    </Grid>
                                    <h3 className={classes.sectionHeading}>Children Details</h3>
                                    {lstChildDetail && lstChildDetail.length > 0 ?
                                        lstChildDetail.map((child, index) => (
                                            !child.isDeleted ? (
                                                <Grid container spacing={3}>
                                                    <Grid item sm={6} md={6} lg={6} xl={6}>
                                                        <Grid row >
                                                            {index == 0 ? <Label title="Child Full Name" size={12} mandatory={true} /> : ''}
                                                            <InputBaseField
                                                                name="fullName"
                                                                value={child.fullName}
                                                                onChange={(e) => handleChildChange(e, index)}
                                                                placeholder={lstChildDetail.length > 1 ? `Child ${index + 1} Full Name` : "Child Full Name"}
                                                                type="text"
                                                                MaxLength={100}
                                                                IsDisabled={isPreviewMode}
                                                            />
                                                            {errorMessages.errorChildName && !child.fullName ? (<FormHelperText style={{ color: "red" }} >
                                                                Please enter child full name
                                                            </FormHelperText>) : ('')}
                                                        </Grid>

                                                    </Grid>
                                                    <Grid item sm={3} md={3} lg={3} xl={3}>
                                                        <Grid row >
                                                            {index == 0 ? <Label title="Age" size={12} mandatory={true} /> : ''}
                                                            <InputBaseField
                                                                name="age"
                                                                value={child.age}
                                                                onChange={(e) => handleChildChange(e, index)}
                                                                placeholder="Age"
                                                                type="text"
                                                                MaxLength={2}
                                                                onKeyPress={handleNumberKeyPress}
                                                                IsDisabled={isPreviewMode}
                                                            />
                                                            {errorMessages.errorChildAge && !child.age ? (<FormHelperText style={{ color: "red" }} >
                                                                Please enter child age
                                                            </FormHelperText>) : ('')}
                                                        </Grid>

                                                    </Grid>
                                                    <Grid item sm={3} md={3} lg={3} xl={3}>
                                                        <Grid row >
                                                            {index == 0 ? <Label title="Gender" size={12} /> : ''}
                                                            <Select
                                                                size="small"
                                                                native
                                                                name="gender"
                                                                value={child?.gender}
                                                                onChange={(e) => handleChildChange(e, index)}
                                                                disabled={isPreviewMode}
                                                                placeholder="Select"
                                                                label="Select"
                                                                className={classes.selectBaseInput}
                                                            >
                                                                <option value="" selected="selected">
                                                                    Select Gender
                                                                </option>
                                                                <option value="Male">Male</option>
                                                                <option value="Female">Female</option>
                                                            </Select>
                                                            {errorMessages.errorChildGender && !child.gender ? (<FormHelperText style={{ color: "red" }} >
                                                                Please select child gender
                                                            </FormHelperText>) : ('')}
                                                        </Grid>

                                                    </Grid>
                                                </Grid>) : ''
                                        )) : ''}
                                    <h3 className={classes.sectionHeading}>Contact Information</h3>

                                    <Grid container spacing={2} >
                                        <Grid item sm={6} md={6} lg={6} xl={6}>
                                            <Grid row >
                                                <Label title="Email Address" size={12} mandatory={true} />

                                                <InputBaseField
                                                    name="email"
                                                    value={state.email}
                                                    onChange={handleChange}
                                                    placeholder="Email Address"
                                                    type="text"
                                                    MaxLength={100}
                                                    IsDisabled={isPreviewMode}
                                                />
                                                {errorMessages.errorEmailAddress && (!state.email || !validateEmail(state.email)) ? (<FormHelperText style={{ color: "red" }} >
                                                    Please enter valid email
                                                </FormHelperText>) : ('')}
                                            </Grid>
                                        </Grid>


                                        <Grid item sm={6} md={6} lg={6} xl={6}>
                                            <Grid row >
                                                <Label title="Phone #" size={12} mandatory={true} />
                                                <InputBaseField
                                                    name="phone"
                                                    value={state.phone}
                                                    onChange={handlePhoneChange}
                                                    placeholder="Phone #"
                                                    type="text"
                                                    MaxLength={14}
                                                    IsDisabled={isPreviewMode}
                                                />
                                                {errorMessages.errorPhone && (!state.phone || !validatePhoneNumber(state.phone)) ? (<FormHelperText style={{ color: "red" }} >
                                                    Please enter valid phone number
                                                </FormHelperText>) : ('')}
                                            </Grid>

                                        </Grid>

                                    </Grid>



                                    <Grid container spacing={2}>
                                        <Grid item sm={6} md={6} lg={6} xl={6}>
                                            <Grid row>
                                                <Label title="Address" size={12} mandatory={true} />
                                                <InputBaseField
                                                    name="address"
                                                    value={state.address}
                                                    onChange={handleChange}
                                                    placeholder="Address"
                                                    type="text"
                                                    MaxLength={500}
                                                    IsDisabled={isPreviewMode}
                                                />
                                                {errorMessages.errorAddress && !state.address ? (<FormHelperText style={{ color: "red" }} >
                                                    Please enter address
                                                </FormHelperText>) : ('')}
                                            </Grid>
                                        </Grid>

                                        <Grid item sm={3} md={3} lg={3} xl={3}>
                                            <Grid row >
                                                <Label title="Zip" size={12} mandatory={true} />
                                                <InputBaseField
                                                    name="zip"
                                                    value={state.zip}
                                                    onChange={handleZipCodeChange}
                                                    placeholder="zip"
                                                    type="text"
                                                    MaxLength={9}
                                                    IsDisabled={isPreviewMode}
                                                    onKeyPress={handleNumberKeyPress}
                                                />
                                                {errorMessages.errorZip && !state.zip ? (<FormHelperText style={{ color: "red" }} >
                                                    Please enter zip code
                                                </FormHelperText>) : ('')}
                                                {errorMessages.errorInvalidZip && state.zip && !allowedZipCodes.some(a => a == state.zip) ? (<FormHelperText style={{ color: "red" }} >
                                                    This program is not available in entered zip code
                                                </FormHelperText>) : ('')}
                                            </Grid>
                                        </Grid>

                                        <Grid item sm={3} md={3} lg={3} xl={3}>
                                            <Grid row >
                                                <Label title="City" size={12} mandatory={true} />
                                                <InputBaseField
                                                    name="city"
                                                    value={state.city}
                                                    onChange={handleChange}
                                                    placeholder="City"
                                                    type="text"
                                                    MaxLength={20}
                                                    IsDisabled={isPreviewMode}
                                                />
                                                {errorMessages.errorCity && !state.city ? (<FormHelperText style={{ color: "red" }} >
                                                    Please enter city
                                                </FormHelperText>) : ('')}
                                            </Grid>

                                        </Grid>


                                    </Grid>
                                    <h4>Please select all that follows</h4>
                                    <Grid container spacing={2}>

                                        <Grid item sm={6} md={6} lg={6} xl={6}>
                                            <Grid row>
                                                <FormControl component="fieldset" className={classes.formControl}>
                                                    <FormGroup>
                                                        {lstHousholdStatus.filter((o, i) => i < 3).map((item, index) => (
                                                            <FormControlLabel
                                                                control={<Checkbox onChange={(e) => handleStatusCheckChange(e, index)} name={item.value} defaultChecked={item.checked} />}
                                                                label={item.value}
                                                            />
                                                        ))}
                                                    </FormGroup>
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                        <Grid item sm={6} md={6} lg={6} xl={6}>
                                            <Grid row>
                                                <FormControl component="fieldset" className={classes.formControl}>
                                                    <FormGroup>
                                                        {lstHousholdStatus.filter((o, i) => i >= 3).map((item, index) => (
                                                            <FormControlLabel
                                                                control={<Checkbox onChange={(e) => handleStatusCheckChange(e, index + 3)} name={item.value} defaultChecked={item.checked} />}
                                                                label={item.value}
                                                            />
                                                        ))}
                                                    </FormGroup>
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                        {errorMessages.errorHouseHoldStatus && !lstHousholdStatus.some(item => item.checked) ? (<FormHelperText style={{ color: "red" }} >
                                            Please select at least one from above options
                                        </FormHelperText>) : ('')}

                                    </Grid>
                                    <Grid container spacing={2} >
                                        <Grid item sm={12} md={12} lg={12} xl={12}>
                                            <Grid row >
                                                <Label title="About Applicant" size={12} mandatory={true} />

                                                <TextareaField
                                                    id="comments"
                                                    name="comments"
                                                    type="text"
                                                    rowsMin={4}
                                                    rows={4}
                                                    value={state.comments}
                                                    onChange={handleChange}
                                                    placeholder="Details about applicant's children/family"
                                                    IsDisabled={false}
                                                    MaxLength={80}
                                                />
                                                {errorMessages.errorComments && !state.comments ? (<FormHelperText style={{ color: "red" }} >
                                                    Please enter details about applicant's children/family
                                                </FormHelperText>) : ('')}
                                            </Grid>
                                        </Grid>

                                    </Grid>
                                    <h3 className={classes.sectionHeading}>Consent and Agreement</h3>

                                    <Grid container spacing={2}>

                                        <Grid item sm={6} md={6} lg={6} xl={6}>
                                            <Grid row>
                                                <Label title="Applicant Signature" size={12} mandatory={true} />
                                                <InputBaseField
                                                    name="applicantSignature"
                                                    value={state.applicantSignature}
                                                    onChange={handleChange}
                                                    placeholder="Applicant Signature"
                                                    IsDisabled={isPreviewMode}
                                                    type="text"
                                                    MaxLength={100}
                                                />
                                                {errorMessages.errorSignature && !state.applicantSignature ? (<FormHelperText style={{ color: "red" }} >
                                                    Please enter signature
                                                </FormHelperText>) : ('')}
                                            </Grid>

                                        </Grid>


                                        <Grid item sm={6} md={6} lg={6} xl={6}>
                                            <Grid row>
                                                <Label title="Applicant Initials" size={12} mandatory={true} />
                                                <InputBaseField
                                                    name="applicantInitials"
                                                    value={state.applicantInitials}
                                                    onChange={handleChange}
                                                    placeholder="Applicant Initials"
                                                    IsDisabled={isPreviewMode}
                                                    type="text"
                                                    MaxLength={2}
                                                />
                                                {errorMessages.errorInitials && !state.applicantInitials ? (<FormHelperText style={{ color: "red" }} >
                                                    Please enter initials
                                                </FormHelperText>) : ('')}
                                            </Grid>

                                        </Grid>
                                    </Grid>
                                    {/*{isData ?*/}
                                    {/*    <>*/}
                                    {/*        <h3 className={classes.sectionHeading}> Proof of Identity </h3>*/}

                                    {/*        <Grid container spacing={2}>*/}
                                    {/*            <Grid item sm={12} md={12} lg={12} xl={12}>*/}
                                    {/*                {identityImage.file || state.identityProof ?*/}
                                    {/*                    <>*/}
                                    {/*                        <img src={identityImage.file ? identityImage.file : '.' + state.identityProof} width="100%" />*/}
                                    {/*                    </>*/}
                                    {/*                    : <img src={PreviewPhoto} width="100%" />*/}
                                    {/*                }*/}
                                    {/*            </Grid>*/}
                                    {/*        </Grid>*/}
                                    {/*    </>*/}
                                    {/*    :*/}
                                    {/*    <>*/}
                                    <h3 className={classes.sectionHeading}> Proof of Identity </h3>

                                    <Grid container spacing={2}>


                                        <Grid item sm={6} md={6} lg={6} xl={6}>
                                            <Grid row>
                                                <Label title="Upload Document" size={12} mandatory={true} />
                                                <input type="file" id="fileUploadField" name="proofOfIdentity" ref={inputFile} className={classes.inputFile} onChange={handleFileChange} accept=".png, .jpg, .jpeg" />

                                                {errorMessages.errorIdentityImage && !identityImage.file ? (<FormHelperText style={{ color: "red" }} >
                                                    Please select document
                                                </FormHelperText>) : ('')}
                                            </Grid>

                                        </Grid>
                                    </Grid>
                                    <Grid container>
                                        {identityImage.file || state.identityProof ?
                                            <>
                                                <div className={classes.previewPhotoMain}>
                                                    <div className={"previewPhotoBorder"} >
                                                        <div className={"previewPhotoBg"}>
                                                            <img src={identityImage.file ? identityImage.file : '.' + state.identityProof} className={classes.previewImg} id="previewimg" style={{ borderRadius: '10px', borderColor: 'gray', borderWidth: '2px', marginTop: '20px', width: '325px', height: '204.1px' }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                            : ''
                                        }
                                    </Grid>

                                    {/*</>}*/}

                                </Grid>


                            </Grid>
                        </div>
                    </Scrollbars>
                    <div className={classes.footer}>
                        <div className={classes.footerRight}>
                            <Button className={classes.backBtn} onClick={handleClose}>Close</Button>
                            {!isPreviewMode ? <Button className={classes.changeBtn} onClick={updateApplicantInformation}>{record?.applicationId > 0 ? "Update" : "Add"}</Button> : ''}

                        </div>
                    </div>
                </div>
            </div>
        </Dialog >
    )
}

export default withSnackbar(EditRequest);
